<!--
 * @FileDescription: 大图预览组件
 * @Author: 朱建波
 * @Date: 2025-05-16
 * @LastEditors: 朱建波 342393950@qq.com
 *
 * @name: ZImageViewer
 *
 * @Props
 * @property {Boolean} visible             是否显示
 * @property {Array} list                  展示的图片
 *
 * @Slots
 *
 * @Methods
 * $emit open                              打开
 * $emit close                             关闭
-->
<template>
  <el-image-viewer v-if="isShow" :url-list="list" :on-close="close"  />
</template>

<script>
import elImageViewer from 'element-ui/packages/image/src/image-viewer'
export default {
  name: 'ZCard',
  props: {
    visible: { type: Boolean, default: false },
    list: { type: Array, default: () => [] }
  },
  components: { elImageViewer },
  data() {
    return {
      isShow: false
    }
  },
  watch: {
    visible: {
      handler(val) {
        this.isShow = val
      },
      immediate: true
    }
  },
  methods: {
    open() {
      this.isShow = true
      this.$emit('open')
      this.$emit('update:visible', true)
    },
    close() {
      this.isShow = false
      this.$emit('close')
      this.$emit('update:visible', false)
    }
  }
}
</script>

<style lang="scss" scoped></style>
